module.exports = __webpack_public_path__ + "img/2d1ea4436d3ec9a4aa45d3131ccda810.png";